import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Upload } from 'lucide-react';

interface ImportTabProps {
  onImportClick: () => void;
  uploading: boolean;
}

export const ImportTab = ({ onImportClick, uploading }: ImportTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Import Questions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-center py-12 border-2 border-dashed border-muted-foreground/25 rounded-lg">
          <Upload className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
          <h3 className="font-semibold mb-2">Upload Questions File</h3>
          <p className="text-muted-foreground mb-4">
            Support for CSV and JSON files with question data
          </p>
          <div>
            <Button onClick={onImportClick} disabled={uploading}>
              <Upload className="h-4 w-4 mr-2" />
              {uploading ? 'Processing...' : 'Choose File'}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};